module.exports = __webpack_public_path__ + "media/cooking-show.66655b1e.mp4";